import React from 'react';
import clsx from 'clsx';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
    useHistory,
    useParams
} from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';
import Copyright from '../../app/Copyright';
import { Avatar, Button, Menu, MenuItem, Modal } from '@material-ui/core';
import { PageParams } from '../../types/Types';
import DashboardPageStyles from './DashboardPageStyles';
import Users from './components/Users';
import MainContents from './components/MainContents';
import AdminRainfallLog from './components/AdminRainfallLog';
import { Menu as MenuItemList } from './components/Menu';
import Profile from '../auth/profile/Profile';
import AdminGauge from './components/AdminGauge';
import AdminScale from './components/AdminScale';
import AdminRiverlevelLog from './components/AdminRiverlevelLog';

const Dashboard: React.FC = () => {
    const classes = DashboardPageStyles();
    const [open, setOpen] = React.useState(false);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    const auth = useAuth();
    const history = useHistory();
    let { page } = useParams<PageParams>();

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const renderSwitch = (param: string) => {
        switch (param) {
            case 'users':
                return <Users />;
            case 'rainfall':
                return <AdminRainfallLog />;
            case 'riverlevel':
                return <AdminRiverlevelLog />;
            case 'raingauge':
                return <AdminGauge />;
            case 'riverscale':
                return <AdminScale />;
            default:
                return <MainContents />;
        }
    }

    const handleSignOut = async () => {
        try {
            await auth?.logout();
            history.push("/signin");
        } catch (error) {
            console.error(error);
        }
    }

    const handleClose = () => {
        setAnchorEl(null);
    };


    const [modalOpen, setModalOpen] = React.useState(false);

    const handleModalOpen = () => {
        setModalOpen(true);
        handleClose();
    };
    const handleModalClose = () => setModalOpen(false);
    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>Dashboard</Typography>
                    <Button onClick={handleClick}>
                        <Avatar>{auth?.currentUser?.displayName?.charAt(0)}</Avatar>
                    </Button>
                </Toolbar>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleModalOpen}>Profile</MenuItem>
                    <MenuItem onClick={handleSignOut}>Logout</MenuItem>
                </Menu>

            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}>
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                <MenuItemList />
            </Drawer>
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                {renderSwitch(page)}
                <Copyright />
            </main>
            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div><Profile /></div>

            </Modal>
        </div>
    );
}

export default Dashboard;